import { action, makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { PopUpViewProps } from "../shared/components/PopUpView";

export enum CommunityView {
  EVENT_CODE_ENTRY = "event_code_entry",
  EVENT_PAGE = "event_page",
  GUEST_LIST = "guest_list",
  GUEST_ADD = "guest_add",
  MANUAL_MATCH = "manual_match",
  SETUPS = "setups",
  SCHEDULE = "schedule",
}

export class CommunityNavigationStore {
  currentView: CommunityView = CommunityView.EVENT_CODE_ENTRY;

  popUpViewProps: PopUpViewProps | null = null;

  authenticatedEvents: string[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    makePersistable(this, {
      name: "CommunityNavigationStore",
      properties: ["currentView", "authenticatedEvents"],
      storage: window.localStorage,
    });
  }

  @action
  setPopUpView = (popUpViewProps: PopUpViewProps | null) => {
    this.popUpViewProps = popUpViewProps;
  };

  @action
  navigateTo = (view: CommunityView) => {
    this.currentView = view;
    this.popUpViewProps = null;
  };

  @action
  reset = () => {
    this.currentView = CommunityView.EVENT_CODE_ENTRY;
  };

  @action
  markEventAuthenticated = (eventGuid: string) => {
    if (!this.authenticatedEvents.includes(eventGuid)) {
      this.authenticatedEvents.push(eventGuid);
    }
  };

  @action
  clearEventAuthentication = (eventGuid: string) => {
    this.authenticatedEvents = this.authenticatedEvents.filter(
      (guid) => guid !== eventGuid,
    );
  };

  isEventAuthenticated = (eventGuid: string) =>
    this.authenticatedEvents.includes(eventGuid);
}

export default new CommunityNavigationStore();
